const SESSION_TOKEN_KEY = "Quire_session_token";
const REFRESH_TOKEN_KEY = "Quire_refresh_token";
const DEVICE_KEY = "Quire_device_key";
let sessionToken: string | null = null;
let refreshToken: string | null = null;
let legacyStoragePurged = false;

function purgeLegacyTokenStorage(): void {
  if (legacyStoragePurged || typeof window === "undefined") {
    return;
  }

  legacyStoragePurged = true;
  try {
    window.localStorage.removeItem(SESSION_TOKEN_KEY);
    window.localStorage.removeItem(REFRESH_TOKEN_KEY);
    window.localStorage.removeItem(DEVICE_KEY);
  } catch {
    // ignore storage failures
  }
}

export function getSessionToken(): string | null {
  purgeLegacyTokenStorage();
  return sessionToken;
}

export function getRefreshToken(): string | null {
  purgeLegacyTokenStorage();
  return refreshToken;
}

export function setSessionToken(token: string): void {
  purgeLegacyTokenStorage();
  sessionToken = token.trim() || null;
}

export function setRefreshToken(token: string): void {
  purgeLegacyTokenStorage();
  refreshToken = token.trim() || null;
}

export function persistAuthTokens(input: {
  sessionToken?: string;
  refreshToken?: string;
}): void {
  if (input.sessionToken) {
    setSessionToken(input.sessionToken);
  }

  if (input.refreshToken) {
    setRefreshToken(input.refreshToken);
  }
}

export function clearAuthTokens(): void {
  purgeLegacyTokenStorage();
  sessionToken = null;
  refreshToken = null;
}

export const clearStoredAuthTokens = clearAuthTokens;
